module.exports = __webpack_public_path__ + "img/daren_1.b4a51fe6.png";